// extracted by mini-css-extract-plugin
module.exports = {"signal":"Signal_signal__3Gr5b","title":"Signal_title__1k5yw"};